import type { NetworkQuality } from 'agora-rtc-sdk-ng'

import { idEq } from '@/tutorCall/constants'

/** 网络质量短标签（Agora 0–6） */
export type NetQualityLabel = '—' | '优' | '良' | '中' | '差'

export function agoraNetToLabel(n: number): NetQualityLabel {
  if (n <= 0) return '—'
  if (n === 1) return '优'
  if (n === 2) return '良'
  if (n === 3) return '中'
  return '差'
}

export function labelsFromNetworkQuality(q: NetworkQuality | undefined): { up: NetQualityLabel; down: NetQualityLabel } {
  if (!q) return { up: '—', down: '—' }
  return {
    up: agoraNetToLabel(q.uplinkNetworkQuality),
    down: agoraNetToLabel(q.downlinkNetworkQuality)
  }
}

export function lookupRemoteNetworkQuality(remote: Record<string, NetworkQuality> | undefined, uid: string | number | undefined): NetworkQuality | undefined {
  if (!remote || uid === undefined || uid === '') return undefined
  const s = String(uid)
  if (remote[s]) return remote[s]
  for (const k of Object.keys(remote)) {
    if (idEq(k, s)) return remote[k]
  }
  return undefined
}

export interface TutorCallMediaUi {
  localNetUp: NetQualityLabel
  localNetDown: NetQualityLabel
  remoteNetUp: NetQualityLabel
  remoteNetDown: NetQualityLabel
  remoteMicOn: boolean
  remoteCamOn: boolean
  localMicOn: boolean
  localCamOn: boolean
}

export const DEFAULT_TUTOR_CALL_MEDIA_UI: TutorCallMediaUi = {
  localNetUp: '—',
  localNetDown: '—',
  remoteNetUp: '—',
  remoteNetDown: '—',
  remoteMicOn: true,
  remoteCamOn: true,
  localMicOn: true,
  localCamOn: true
}
